import React, { useState } from 'react'
import styled from 'styled-components'

import { colors } from '../../theme'

const TabList = styled.ul`
  list-style: none;
  display: flex;
  margin: 16px 0;
  padding: 0;
  border-bottom: solid 1px rgba(51, 51, 51, 0.3);
`

export default function (props) {
  const { children } = props

  const [activeTabIndex, setActiveTabIndex] = useState(0)

  function handleTabClick(tabIndex) {
    setActiveTabIndex(tabIndex)
  }

  return (
    <div>
      <TabList>
        {React.Children.map(children, (child, index) => {
          if (child) {
            return React.cloneElement(child, {
              label: child.props.label,
              onTabClick: handleTabClick,
              tabIndex: index,
              active: index === activeTabIndex,
            })
          }
        })}
      </TabList>
      {children[activeTabIndex] && (
        <div>{children[activeTabIndex].props.children}</div>
      )}
    </div>
  )
}
